import { render, staticRenderFns } from "./IdAuth.vue?vue&type=template&id=09165994&"
import script from "./IdAuth.vue?vue&type=script&lang=js&"
export * from "./IdAuth.vue?vue&type=script&lang=js&"
import style0 from "./IdAuth.vue?vue&type=style&index=0&id=09165994&prod&lang=scss&scss=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports